// LayoutStyles.js
import styled from "styled-components/macro";

// Wrapper for the whole layout
export const LayoutWrapper = styled.div`
  display: flex;
  height: 100vh;
  overflow: hidden;
  position: relative;
`;

// Sidebar container
export const SidebarContainer = styled.div`
  position: relative;
  top: 0;
  left: 0;
  height: 100%;
  width: 240px;
  min-width: 240px;

  transition: width 0.3s ease;
  z-index: 10;
  border-right: 1px solid var(--Neutral-8);
  background: var(
    --Neutral-4,
    linear-gradient(
      0deg,
      rgba(31, 31, 31, 0.04) 0%,
      rgba(31, 31, 31, 0.04) 100%
    ),
    #fff
  );

  /* &:hover {
    .sidebar-content {
      .click-side-bar-expand {
        opacity: 1;
      }
    }
  } */

  .sidebar-content {
    position: relative;

    .click-side-bar-expand {
      position: absolute;
      top: 16px;
      right: 16px;
      cursor: pointer;
      opacity: ${({ $isClicked }) => ($isClicked ? 1 : 0)};
      transition: opacity 0.3s ease;
      margin: 8px;

      &.rotated {
        transform: rotate(180deg);
      }

      &.internal-admin {
        top: 26px;
      }
    }
  }
`;

// Main content container
export const ContentContainer = styled.div`
  flex: 1;
  height: 100%;
  background-color: #ffffff;
  width: -webkit-fill-available;
  padding: 16px;
  width: calc(100% - 240px);

  &::-webkit-scrollbar {
    height: 8px;
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background-color: var(--Neutral-8);
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: var(--Neutral-60);
    border-radius: 10px;
    border: 1px solid transparent;
    background-clip: content-box;
  }
`;
